import * as angular from "angular";
import { CampaignService } from "../services/campaign.service";
import { ActivityFilter } from "../models/activity-filter.model";
import { User } from "../models/user.model";
import { ActivityService } from "../services/activity.service";

export class ActivityDataProvider {
    public activities = [];
    public warnings = null;
    public filters: ActivityFilter;
    public houseActivity = [];
    public houseActivityHid = null;
    public warningsPromise = null;

    private $q: any;
    private $timeout: any;

    private activityService: ActivityService;
    private campaignService: CampaignService;

    constructor(
        $q: any,
        $timeout: any,
        ActivityService: ActivityService,
        CampaignService: CampaignService
    ) {
        this.$q = $q;
        this.$timeout = $timeout;

        this.activityService = ActivityService;
        this.campaignService = CampaignService;
    }

    clearAll(): void {
        this.warnings = [];
    }

    getFilters(): ActivityFilter {
        return this.filters;
    }

    setFilters(setFilters: ActivityFilter): void {
        // this.filters = setFilters;
        //
        // this.filters.uids.values = [];
        // angular.forEach(
        //     this.filters.uids.selectedUsers,
        //     (selectedUser: User) => {
        //         this.filters.uids.values.push(selectedUser.uid);
        //     }
        // );
    }

    removeActivity(activity: any): void {
        // this.activities.splice(this.activities.indexOf(activity), 1);
        // this.infiniteItems.numLoaded_ -= 1;
    }

    getWarnings(): Promise<object> {
        if (this.warnings !== null) {
            return this.$q.resolve(this.warnings);
        } else if (this.warningsPromise) {
            return this.warningsPromise;
        } else {
            const deferred = this.$q.defer();
            this.campaignService.warnings().then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.warnings = [];
                    angular.forEach(
                        json.data,
                        (items: any, warning_type: any) => {
                            if (items.length)
                                this.warnings.push({
                                    name: warning_type,
                                    items: items,
                                });
                        }
                    );
                    deferred.resolve(this.warnings);
                } else {
                    deferred.reject();
                }
            });
            this.warningsPromise = deferred.promise;
            return this.warningsPromise;
        }
    }

    addToActivityList(activity: any): void {
        // if (activity.length < 25) {
        //     this.infiniteItems.end = true; //no more activity to load.
        // }
        // this.activities = this.activities.concat(activity);
        // this.infiniteItems.numLoaded_ = this.activities.length;
        // this.infiniteItems.loading = false;
    }

    getAllActivity(filter: ActivityFilter, offset: number): Promise<object> {
        const deferred = this.$q.defer();
        let filterObj = filter.nonEmptyValues();
        this.activityService.all({ filter: filterObj, offset: offset }).then(
            (response: object) => {
                const json = response["data"];
                deferred.resolve(json.data);
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getHouseActivity(hid: string | number): Promise<Array<any>> {
        const deferred = this.$q.defer();
        this.houseActivityHid = hid;
        this.activityService.house({ id: hid }).then(
            (response: object) => {
                const json = response["data"];
                this.houseActivity = json.data;
                deferred.resolve(this.houseActivity);
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getLocationActivity(locationid: string | number): Promise<object> {
        const deferred = this.$q.defer();
        this.activityService.location({ id: locationid }).then(
            (response: object) => {
                const json = response["data"];
                deferred.resolve(json.data);
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getHouseOccupantActivity(
        hoid: string,
        filter?: ActivityFilter,
        offset?: number
    ): Promise<object> {
        const deferred = this.$q.defer();
        let filterObj: object | undefined;
        if (filter) {
            filterObj = filter.nonEmptyValues();
        }
        this.activityService
            .houseoccupant({ id: hoid, filter: filterObj, offset: offset })
            .then(
                (response: object) => {
                    const json = response["data"];
                    deferred.resolve(json.data);
                },
                (error: object) => deferred.reject(error)
            );
        return deferred.promise;
    }

    processSocketCreate(socketData: any): any {
        if (this.filters) {
            const checkActivatedFilter = Object.keys(this.filters).filter(
                (key) => {
                    if (this.filters[key].checked === true) {
                        return this.filters[key];
                    }
                }
            );

            if (this.activities) {
                this.$timeout(() => {
                    if (checkActivatedFilter.length === 0) {
                        this.activities.unshift(socketData);
                        if (
                            socketData.hasOwnProperty("hid") &&
                            socketData.hid == this.houseActivityHid
                        ) {
                            this.houseActivity.unshift(socketData);
                        }
                    }
                });
            }
        }
    }
}

export class ActivityInfiniteItems {
    public numLoaded_ = 0;
    public toLoad_ = 0;
    public loading = false;
    public end = false;
    public dataProvider: ActivityDataProvider;
    public items: any[];
    public filter: ActivityFilter;

    constructor(
        items: any[],
        filter: ActivityFilter,
        dataProvider: ActivityDataProvider
    ) {
        this.items = items;
        this.filter = angular.copy(filter);
        this.dataProvider = dataProvider;
    }

    setFilter(filter: ActivityFilter) {
        this.filter.setData(filter);
    }

    getItemAtIndex(index: number): any {
        if (index > this.numLoaded_ - 1) {
            this.fetchMoreItems_(index);
            return null;
        }
        return this.items[index];
    }

    // For infinite scroll behavior, we always return a slightly higher
    // number than the previously loaded items.
    getLength(): number {
        if (this.end) return this.numLoaded_;
        return this.numLoaded_ + 8;
    }

    fetchMoreItems_(index: number): void {
        if (this.toLoad_ < index) {
            this.loading = true;
            this.toLoad_ += 25;
            let offset = this.numLoaded_;
            offset = offset > 0 ? offset : 0;

            this.dataProvider
                .getAllActivity(this.filter, offset)
                .then((activity: any): void => {
                    // this.dataProvider.addToActivityList(activity);

                    if (activity.length < 25) {
                        this.end = true; //no more activity to load.
                    }
                    this.items = this.items.concat(activity);
                    this.numLoaded_ = this.items.length;
                    this.loading = false;
                });
        }
    }

    reset(): void {
        this.items = [];
        this.numLoaded_ = 0;
        this.toLoad_ = 0;
        this.end = false;
    }
}

angular
    .module("vcDataProvider", [])
    .service("ActivityDataProvider", ActivityDataProvider);
